import '../assets/css/gestion.css';
import React, { useState, useEffect} from 'react';
import Loader from '../assets/img/loader.svg';
import Warning from '../assets/img/icon-warning.svg';
import {Link} from "react-router-dom";
export const Gestion = (props) => {
    const [popUp, setPopUp] = useState(false)
    const googleSpreadGestion= 'https://sheets.googleapis.com/v4/spreadsheets/1kWWRdloyNwr3phtvKUEulHbaC7_wz0_OIKoBLlqIvP0/values/A2:E?key=AIzaSyAGavQjafyO17-8l5wtn6-cPyLgJVtk_3I' // Si les champs sont ok
    
    
    
    
    const [data, setData] = useState([])
    const [filterGestion, setFilterGestion] = useState('')
    const [refresh,setRefresh] = useState(0)
useEffect(() => {
    
    fetch(googleSpreadGestion)
    .then(res => res.json()
    )
    .then(
      (result) => {
        setData(result.values.reverse())
        
        return
      },
      (error) => {
          setData('error')
          
      }
    )
 return ()=> setData([])
}, [refresh])



return(


<div id="gestion">
<button className="btnAdd" type="button"
onClick={(e) => { setPopUp(true)}}><span>+</span></button>
<div className="links">

{data.filter(filtre => filtre[3].includes("no"))
    .map((item) => {
         return (
        <div key={item[0]} className={item[4]}>
       
        {item[1].match(/^https*/gm )?
        
        <a target="_blank" href={item[1]}>{item[1]}</a>:
        
        <Link to={item[1]}>{item[1]}</Link>}
       

        <form name={"removebutton"+item[0]} onSubmit={(event) => {
                        event.preventDefault()

                        const scriptURL = 'https://script.google.com/macros/s/AKfycbybk6NLe6wQR8J5CuDl_lJjzLGiFSUsUAbiBFVneVrK87-i0Lol69IHM4LDea92Oiu1hQ/exec'
                        const form = document.forms["removebutton"+item[0]]
                        fetch(scriptURL, { method: 'POST', body: new FormData(form) })
                            .then(response => {
                                setRefresh(refresh+1)
                                
                            })
                            .catch(error => {
                                //console.log("nok POST")
                            })}
                        }>
                            <input type="text" name="removed" readOnly value={item[0]}/>
                            <button action="" method="" type="submit"
                            onClick={(event) => {
                               event.target.parentElement.parentElement.parentElement.classList.add("hidden")
                                setTimeout(function(){ 
                                event.target.parentElement.parentElement.parentElement.classList.replace("hidden","displayNone")
                                }, 200);


                             }}
                            
                            
                            ><span>×</span></button></form>





















         </div>
         )})}
        
   

</div>
{popUp==true?
<div className="modalGestion">
    <div className="close-btn" onClick={(e) => {setPopUp(false)}}>×</div>
    <div className="titlePopUpGestion">Ajouter un raccourci</div>
    <form name="submit-to-google-sheet" onSubmit={(event) => {
                                event.preventDefault()
                                const scriptURL = 'https://script.google.com/macros/s/AKfycbybk6NLe6wQR8J5CuDl_lJjzLGiFSUsUAbiBFVneVrK87-i0Lol69IHM4LDea92Oiu1hQ/exec'
                                const form = document.forms['submit-to-google-sheet']
                                fetch(scriptURL, { method: 'POST', body: new FormData(form) })
                                    .then(response => {

                                        setRefresh(refresh+1)
                                        setPopUp(false)
                                        
                                    })
                                    .catch(error => {
                                    })}
                                }>
    <div>
        <label htmlFor="titleGestion">Titre</label>
        <input type="text" name="titleGestion" id="titleGestion" required />
    </div>
    <div>
        <label htmlFor="linkGestion">Lien</label>
        <input type="text" name="linkGestion" id="linkGestion" required />
    </div>
    <div className="color">
    <p>Couleur</p>
        <div>
            <input type="radio" id="green" name="color" value="green" />
            <label htmlFor="green">Vert</label>
            <input type="radio" id="pink" name="color" value="pink" />
            <label htmlFor="pink">Rose</label>
            <input type="radio" id="orange" name="color" value="orange" />
            <label htmlFor="orange">Orange</label>
            <input type="radio" id="purple" name="color" value="purple" />
            <label htmlFor="purple">Violet</label>
            <input type="radio" id="blue" name="color" value="blue" />
            <label htmlFor="blue">Blue</label>
        </div>
    </div>
    <input type="text" name="removed" id="removed" readOnly value="no"/>
    <button action="" method="" type="submit">Ajouter <span>+</span></button>
    </form>
</div>



:""}


</div>)
    
}

